<template>
    <svg id="radiology" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 16.363 27.271">
        <path id="Path_69963" data-name="Path 69963"
              d="M77.6,194.716h-.15v-1.364h.031a12.907,12.907,0,0,1,2.72.145.455.455,0,0,0,.886-.144.669.669,0,0,0-.2-.482c-.416-.415-1.4-.432-3.4-.428h-.029a.455.455,0,0,0-.909,0h-.029c-2.006,0-2.987.013-3.4.428a.669.669,0,0,0-.2.482.455.455,0,0,0,.886.144,12.916,12.916,0,0,1,2.72-.145h.031v1.364h-.15c-2.594,0-3.761.013-4.2.451a.646.646,0,0,0-.195.458.455.455,0,0,0,.876.17,17.713,17.713,0,0,1,3.517-.17h.152v1.364h-.029c-2.006,0-2.987.013-3.4.428a.669.669,0,0,0-.2.482.455.455,0,0,0,.886.144,12.9,12.9,0,0,1,2.72-.145h.031v1.364H75.182a.455.455,0,0,0-.455.455,2.273,2.273,0,0,0,4.545,0,.455.455,0,0,0-.455-.455H77.454V197.9h.031a12.9,12.9,0,0,1,2.72.145.455.455,0,0,0,.886-.144.669.669,0,0,0-.2-.482c-.416-.415-1.4-.432-3.4-.428h-.029v-1.364h.152a17.727,17.727,0,0,1,3.517.17.455.455,0,0,0,.876-.17.646.646,0,0,0-.195-.458C81.365,194.729,80.2,194.712,77.6,194.716Zm.681,5.455a1.364,1.364,0,0,1-2.571,0Z"
              transform="translate(-68.818 -181.99)" fill="#799cfb"/>
        <path id="Path_69964" data-name="Path 69964"
              d="M16.455,37.817h3.636v3.636a1.818,1.818,0,0,0,3.636,0V37.817h.909v3.636a1.818,1.818,0,0,0,3.636,0V37.817h3.636a.455.455,0,0,0,.455-.455V24.636a.455.455,0,0,0-.455-.455h-1.4a3.186,3.186,0,0,0-3.149-2.727h-1.5a4.123,4.123,0,0,0,.309-.42,4.557,4.557,0,0,0,.738-2.308,2.727,2.727,0,0,0-5.454,0,4.557,4.557,0,0,0,.738,2.308,4.122,4.122,0,0,0,.309.42H21a3.186,3.186,0,0,0-3.149,2.727h-1.4a.455.455,0,0,0-.455.455V37.362A.455.455,0,0,0,16.455,37.817Zm6.363,3.636a.909.909,0,0,1-1.818,0V37.817h1.818Zm4.545,0a.909.909,0,0,1-1.818,0V37.817h1.818Zm-5-22.726a1.818,1.818,0,0,1,3.636,0c0,1.127-.94,2.727-1.818,2.727S22.363,19.854,22.363,18.727ZM21,22.363h6.363a2.277,2.277,0,0,1,2.227,1.818H18.773A2.277,2.277,0,0,1,21,22.363ZM16.909,25.09H31.454V36.908H16.909Z"
              transform="translate(-16 -16)" fill="#799cfb"/>
    </svg>
</template>

<script>
    export default {
        name: "IRadiologyNoBg",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
